import { ReactNode } from 'react'

interface OverlayType {
  children: ReactNode
  mode: 'dark' | 'light'
}

const Overlay = ({ children, mode = 'light' }: OverlayType) => {
  return (
    <div
      className={
        mode === 'dark'
          ? 'wc-smart-meter__overlay wc-smart-meter__overlay--dark'
          : 'wc-smart-meter__overlay'
      }
    >
      {children}
    </div>
  )
}

export default Overlay
